module.exports = __webpack_public_path__ + "img/icon_contact_us_hover.b69024c.svg";